import { SET_SERVER_DATA_ACTION } from './ServerDataConstants';
import axios from 'axios';

export const setServerData = serverData => ({
    type: SET_SERVER_DATA_ACTION,
    payload: serverData
});

export const getServerData = url => dispatch => {
    return axios
        .get(url, {
            params: {
                json: true
            }
        })
        .then(response => {
            const { data } = response;
            if (typeof data.serverData === 'object') {
                dispatch(setServerData(data.serverData));
            }
        })
        .catch(error => {
            window.capeLog && window.capeLog(`getServerData:error: ${error}`);
        });
};

export const saveDataInSession = (url, data) => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;
    return axios
        .request({
            method: 'post',
            url,
            headers: {
                'X-CSRF-Token': _csrf
            },
            data
        });
};
